import App from 'app/app.js';
import 'app/store/JobStore.js';
import 'app/store/VisualMerchandiseStore.js';

function LtCyopSummaryCtrl($scope, $timeout, JobStore, VisualMerchandiseStore, CustomizationImageService) {
  this.init = function () {
    $timeout(function () {
      if ($scope.isScrollable) {
        $('#sticky').stickyfloat({
          duration: 0,
          offsetY: 0,
          parent: $('#auto-scroll')
        });
      }
    });
  };

  this.getEstimatedAmount = function () {
    if ($scope.orderLine && $scope.orderLine.orderable) {
      var estAmount = $scope.orderLine.orderable.unitPrice;
      var selectedEnhancements = $scope.upgradeOptions;
      selectedEnhancements.forEach((enhancement) => {
        if (enhancement.orderLine?.orderable) {
          estAmount += enhancement.orderLine.orderable.unitPrice;
        }
      });
      return estAmount + this.getPremiumBackgroundTotalAmount();
    }
  };

  this.saveToCart = function () {
    $scope.onSave();
  };

  this.onChooseEnhancement = function () {
    $scope.onChooseEnhancement();
  };

  this.isCyopCheckCompleted = function (orderLineDetail) {
    if (orderLineDetail && orderLineDetail.item) {
      orderLineDetail.item.cyopCheckCompleted = $scope.isCyopCheckCompleted({ orderLineDetail: orderLineDetail });
    }
  };

  this.hideDisclaimer = function () {
    return !JobStore.isPreOrder() && VisualMerchandiseStore.getVisualMerchandise().useSubjectImages;
  };

  this.completedItems = function () {
    return R.reduce(function (acc, orderLineDetail) {
      return acc + $scope.isCyopCheckCompleted({ orderLineDetail: orderLineDetail });
    }, 0)($scope.orderLine.orderLineDetails);
  };

  this.isPremiumBackground = (orderLineDetail) => {
    return Boolean(orderLineDetail.look?.background?.premiumUpgrade);
  };

  this.isPremiumBgIncludedForItem = (index, orderLineDetail) => {
    return CustomizationImageService.isPremiumBgIncludedForItem(index, orderLineDetail.look.background);
  };

  this.getPremiumUpgradeLabel = (index, orderLineDetail) => {
    return CustomizationImageService.getPremiumUpgradeLabel(index, orderLineDetail.look.background);
  };

  this.getPremiumBackgroundTotalAmount = () => {
    return $scope.orderLine.orderLineDetails.reduce((acc, orderLineDetail, index) => {
      if (this.isPremiumBackground(orderLineDetail) && !this.isPremiumBgIncludedForItem(index, orderLineDetail)) {
        return acc + orderLineDetail.look.background.premiumUpgrade.unitPrice;
      }
      return acc;
    }, 0);
  };
}

App.controller('LtCyopSummaryCtrl', [
  '$scope',
  '$timeout',
  'JobStore',
  'VisualMerchandiseStore',
  'CustomizationImageService',
  LtCyopSummaryCtrl
]);
